<template>
  <b-card no-body>
    <b-card-header class="p-0 pb-1 pt-1">
      <div class="d-flex align-items-center">
        <feather-icon
          size="24"
          class="mr-1"
          icon="PaperclipIcon"
        />
        <b-card-title class="ml-25">
          {{ $t('attachments.list-attachments') }}
        </b-card-title>
      </div>
    </b-card-header>
    <b-card-body class="p-0 mt-2">
      <b-table
        ref="refListTable"
        class="position-relative"
        :items="fetchItems"
        responsive
        striped
        :fields="tableColumns"
        show-empty
        :empty-text=" $t('attachments.no-attachments')"
      >
        <!-- Column: Filename -->
        <template #cell(filename)="data">
          <b-media vertical-align="center">
            <b-avatar
              size="32"
              variant="light-secondary"
              rounded
            >
              <feather-icon
                :icon="`${resolveFileIcon(data.item.filename)}Icon`"
                size="18"
              />
            </b-avatar>
            <span class="ml-1">{{ data.item.filename }}</span>
          </b-media>
        </template>
        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <b-link
            v-b-tooltip.hover
            :title="$t('common.download')"
            class="text-nowrap ml-1"
            @click="download(data.item.fid)"
          >
            <feather-icon
              icon="DownloadIcon"
              class="cursor-pointer"
              size="16"
            />

          </b-link>
          <b-link
            v-b-tooltip.hover
            :title="$t('common.delete')"
            class="text-nowrap ml-1"
            @click="remove(data.item.fid)"
          >
            <feather-icon
              icon="TrashIcon"
              class="cursor-pointer"
              size="16"
            />

          </b-link>
        </template>
      </b-table>

      <b-input-group class="mt-2">
        <b-form-file
          ref="uploader"
          size="sm"
          :placeholder="$t('attachments.placeholder')"
          :drop-placeholder="$t('attachments.drop-placeholder')"
        />
        <b-input-group-append>
          <b-button
            variant="outline-primary"
            size="sm"
            @click="upload()"
          >
            <feather-icon
              icon="UploadIcon"
              class="mr-50"
            />
            <span class="align-middle">{{ $t('attachments.upload') }}</span>
          </b-button>
        </b-input-group-append>
      </b-input-group>

    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardBody, BCardHeader, BButton, BCardTitle, BFormFile, BInputGroup, BInputGroupAppend, BTable, BMedia, BAvatar, BLink, VBTooltip,
} from 'bootstrap-vue'
import axios from '@axios'
import { ref } from '@vue/composition-api'
import {
  formatFileType, resolveFileIcon, formatBytes, formatDateHumanFriendly, download,
} from '@/views/layouts/layouts.utils'

export default {
  components: {
    BCard, BCardBody, BCardHeader, BButton, BCardTitle, BInputGroupAppend, BFormFile, BInputGroup, BTable, BMedia, BAvatar, BLink,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  props: {
    value: {
      type: Array,
      default: null,
    },
    // eslint-disable-next-line vue/require-prop-types
    refaid: {
      required: true,
    },
  },
  computed: {
    uuids: {
      get() { return this.value },
      set(value) { this.$emit('input', value) },
    },
  },
  mounted() {
    this.refetchData()
  },
  methods: {
    remove(fid) {
      this.uuids = this.uuids.filter(p => p && p.toString().toLowerCase() !== fid.toString().toLowerCase())
      this.refetchData()
    },
    async download(fid) {
      const response = await axios.get('/api/storage',
        {
          params: { aid: this.refaid, fid },
          responseType: 'blob',
        })
      download(response)
    },
    async upload() {
      const formData = new FormData()
      const file = this.$refs.uploader.files[0]
      formData.append('upload', file, file.name)
      const response = await axios.put('/api/storage', formData, {
        params: { aid: this.refaid },
        headers: { 'Content-Type': 'multipart/form-data' },
      })

      this.$refs.uploader.reset()
      const attachment = response.data[0]
      if (!this.uuids) this.uuids = [attachment]
      else this.uuids.push(attachment)
      this.refetchData()
    },
    refetchData() {
      this.$refs.refListTable.refresh()
    },
    fetchItems(ctx, callback) {
      if (!this.uuids) {
        this.totalItems = 0
        callback([])
      } else {
        axios.post('/api/storage', { aid: this.refaid, fids: this.uuids })
          .then(response => {
            const items = response.data
            callback(items)
            this.totalItems = items.length
          })
      }
    },
  },
  setup() {
    // Table Handlers
    /* eslint-disable object-curly-newline */
    const tableColumns = [
      { key: 'filename', label: 'Filename' },
      { key: 'size', label: 'Size', formatter: (value, key, item) => formatBytes(item.size) },
      { key: 'filetype', label: 'File type', formatter: (value, key, item) => formatFileType(item.filename) },
      { key: 'lastUpdate', label: 'Ultima mod.', formatter: formatDateHumanFriendly },
      { key: 'actions', label: 'Azioni' },
    ]

    const totalItems = ref(0)
    return {
      tableColumns,
      totalItems,
      resolveFileIcon,
    }
  },
}
</script>
